import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { JobService } from '../../services/jobs/job.service'
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LearnerService } from 'src/app/services/learner.service';
import { EditLearnerModalComponent } from 'src/app/learners/edit-learner-modal/edit-learner-modal.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs';
import { StaffService } from 'src/app/services/staff/staff.service';
import { EditStaffModalComponent } from 'src/app/staff/edit-staff-modal/edit-staff-modal.component';
import { MpService } from 'src/app/services/staff/mp.service';
import { TestedIndividualService } from 'src/app/services/tested-individual.service';
import { EditCandidateModalComponent } from 'src/app/medical/edit-candidate-modal/edit-candidate-modal.component';
import { AddCandidateModalComponent } from 'src/app/medical/add-candidate-modal/add-candidate-modal.component'
import { UtilityService } from 'src/app/services/utility.service';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserRoleService } from 'src/app/services/user-role.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  currentUser: any;
  job;
  instructor: any;
  client: any;
  location: any;
  course: any;
  learner: any;
  name: any;
  email: any;
  mobile: any;
  profilePath;
  view;
  isLearner: Boolean = false;
  isInstructor: Boolean = false;
  dateOfJoining: Date;
  isJob: boolean = false;
  hideActions: boolean = false;
  showClientProfile = false;
  user;
  // profileFile: any = [];
  @Input('jobOfInstructor') instructorJobs;
  @Input('learnerForProfile') learnerId;
  @Input('userDetails') userDetails;
  @Input('instructorForProfile') instructorId;
  @Input('updatedInstructor') updatedInstructor;
  @Input('mpForProfile') mpId;
  @Input('jobDetailsForProfile') jobDetails;
  @Output() profileFile: EventEmitter<any> = new EventEmitter<any>();
  displayLinksLearner: boolean;
  displayLinksInstructor: boolean;
  hideJobTitle: boolean = false;
  isMp: boolean;
  mp: any;
  displayUserName: boolean;
  showEdit: boolean = false;
  tedtedIndividual: any;
  testedIndividualId: any;
  jobId: any;
  jobByInstructorId: any;
  isMpLearner = false
  deletedUser
  jobTitle
  isIncidentUser: boolean;
  url1: any;
  insuranceNumber: any;
  sentinelNumber: any;
  // isStaff
  numDisplay: boolean = false;
  isEmployer: boolean = true
  // @Input('job') jobFromLearner;
  private jobFromJobsComponent: Subject<any> = new Subject<any>();
  isStaff: boolean = false;
  singleJob: any;
  constructor(private _jobService: JobService, public _mpService: MpService, public _learnerService: LearnerService,
    public _staffService: StaffService, public _testedIndividualService: TestedIndividualService, public _userRoleService: UserRoleService,
    private activatedRoute: ActivatedRoute, private router: Router, public dialog: MatDialog, public _snackBar: MatSnackBar) {

    this._jobService.getJobFromJobsComponent()
      .pipe(takeUntil(this.jobFromJobsComponent))
      .subscribe((res) => {
        console.log("Jobs found ====>", res)
        this.jobByInstructorId = res;
      })
  }

  ngOnDestroy() {
    this.jobFromJobsComponent.next()
    this.jobFromJobsComponent.complete()
  }

  ngOnInit() {
    console.log("-----learner-----", this.learnerId);
    console.log("-----instructor-----", this.instructorId);
    console.log("-----job-----", this.jobDetails);
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("login user role======", this.user);
    console.log("login currentUser======", this.currentUser);

    this.hideActions = (this.user.isClient) ? true : false
    this.activatedRoute.params.subscribe(param => {
      console.log("PARAM!!!!!!!!!!", param)
      // if(param)
    })

    this.activatedRoute.queryParams.subscribe(qparams => {
      this.jobId = qparams.jobId
      console.log('qparams===================>', this.jobId);

      if (qparams && (qparams.isTestedIndividual == true || qparams.isTestedIndividual == 'true') && (qparams.isLearner == false || qparams.isLearner == 'false')) {
        this.activatedRoute.params.subscribe(params => {
          console.log("Params User Id====>", params['id']);
          this.testedIndividualId = params['id']
          this.showEdit = true
          this.getTestedIndividual(params)
        })
      } else if (qparams && (qparams.isTestedIndividual == true || qparams.isTestedIndividual == 'true') && (qparams.isLearner == true || qparams.isLearner == 'true')) {
        this.activatedRoute.queryParams.subscribe(params => {
          console.log("Params User Id====>", params);
          // this.testedIndividualId = params['id']
          this.showEdit = true
          this.getLearner()
          this.getMpJob()
          // this.getTestedIndividual(params)
        })
      }
    })
    if (this.router.url.includes('/jobs') || this.router.url.includes('/client')) {
      this.hideJobTitle = true;
    }
    // console.log("this.current user is ", this.curremt)
    this.displayLinksLearner = (this.user.isLearner) ? false : true
    if (this.user.isAdmin || this.user.isClient) {
      this.showClientProfile = true
    }
    // this.displayLinksInstructor = (this.currentUser.userRole == 'instructor') ? false : true
    if (this.learnerId != undefined) {
      this.isLearner = true
      this.getLearner()
    }
    else if (this.instructorId != undefined) {
      this.isInstructor = true;
      this.isIncidentUser = false
      console.log("instructor recieved is", this.instructorId);
      this.getInstructor();
    }
    else if (this.jobDetails != undefined) {
      this.isJob = true
      this.getJobValues(this.jobDetails)
      console.log("JOB DETAILS FOR LEARner", this.jobDetails)
    }
    else if (this.mpId != undefined) {
      this.isMp = true;
      this.getMp()
    }



  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes in profile", changes);
    if (changes.jobDetails != undefined) {
      if (changes.jobDetails.currentValue != undefined) {
        console.log("ngon changes job==>", changes.jobDetails.currentValue)
        this.getJobValues(changes.jobDetails.currentValue)
        this.job = changes.jobDetails.currentValue[0]
        let userRole = this._userRoleService.getUserRole(this.job.instructors, 'job')
        if (userRole.isIQA) this.isEmployer = false
        else this.isEmployer = true
      }
    }
    if (changes.instructorId) {
      if (changes.instructorId.currentValue) {
        this.instructorId = changes.instructorId.currentValue;
        this.getInstructor()
      }
    }
    if (changes.updatedInstructor != undefined) {
      if (changes.updatedInstructor.currentValue) {
        this.email = changes.updatedInstructor.currentValue.email
        this.name = changes.updatedInstructor.currentValue.name
        this.mobile = changes.updatedInstructor.currentValue.mobile
        this.sentinelNumber = changes.updatedInstructor.currentValue.sentinelNumber
        this.insuranceNumber = changes.updatedInstructor.currentValue.insuranceNumber
      }
    }
  }




  checkUserRole() {
    // switch (item) {
    //   case 'competencies':
    if (this.currentUser.userRole.includes('admin') || this.currentUser.userRole.includes('mp') || this.currentUser.userRole.includes('trainer') || this.currentUser.userRole.includes('IQA') || this.currentUser.userRole.includes('client') || this.currentUser.userRole.includes('operative')) {
      // console.og("call this portion or not", this.instructor);
      let userRole = this.instructor.userId.userRole
      if (userRole.includes('mp') || userRole.includes('trainer') || userRole.includes('IQA') || userRole.includes('client') || userRole.includes('operative')) {

        return true
      } else {
        return false
      }
    } else {
      return false
    }
    // break;
    // }
  }


  addProfileImage(event: any) {
    console.log("event", event);

    // this.profileFile = event.target.files;
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (event: any) => {
        console.log("what is event", event);

        this.url1 = event.target.result;
        // console.log("after response of url", this.url1);
      }

      reader.readAsDataURL(event.target.files[0]);
      this.profileFile.emit(event.target.files[0])
    }
  }

  async goToCourse(job) {
    console.log("job ??  ", job);
    //   let navigationExtras: NavigationExtras = {
    //     state: {
    //       job: job
    //     }
    //   };
    this.singleJob = job
    let userRole = await this.getUserRole()
    console.log("userRole !!!!  ", userRole);
    let param = {
      userRole: userRole
    }
    this.router.navigate(['/course/materials/' + this.course.templateId], { queryParams: param })
    //  this.router.navigateByUrl('/materials/' + this.course.templateId, navigationExtras);

  }

  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.singleJob.instructors, 'job');
    console.log("getRole ?? ", getRole);
    if (getRole.isAdmin) return 0
    else if (getRole.isLearner) return 3
    else if (getRole.isClient) return 4
    else if (getRole.isTrainer) return 1
    else if (getRole.isIQA) return 2
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  getLearner() {
    this.activatedRoute.queryParams.subscribe(qparams => {
      console.log('qparams===================>', qparams);
      this.jobId = qparams.job || qparams.jobId
    })
    console.log("when it is call from profile", this.testedIndividualId);
    if (this.testedIndividualId == undefined) {


      this._learnerService.getLearner(this.learnerId, this.jobId).subscribe(learner => {
        this.learner = learner.pop();
        console.group("LEARNER")
        console.log("learner:::", this.learner);
        if (this.learner) {
          this.name = this.learner.name;
          this.displayUserName = true
          console.log("this.name", this.name)
          this.email = this.learner.email;
          console.log("this.email", this.email);
          this.mobile = this.learner.phone;
          console.log("this.mobile");
          this.profilePath = this.learner.profilePic;
          if (this.learner && this.learner.operativeUser) {
            this.numDisplay = true
            this.sentinelNumber = this.learner.operativeUser.sentinelNumber
            this.insuranceNumber = this.learner.operativeUser.insuranceNumber
          }
          console.log("this.learner.job._id", this.learner.job[0]._id);
          let jobId

          this.activatedRoute.queryParams.subscribe(qparams => {
            console.log("qparams==========", qparams);
            if (qparams) {
              jobId = qparams.job
            }
          })
          if (jobId == undefined) {
            jobId == this.learner.job[0]._id
          }

          console.log("what is the job id", jobId);


          if (jobId != undefined) this.getJob(jobId);
          console.log("The learner is", this.learner);
          console.groupEnd()
        }

      })
    }
  }

  getInstructor() {
    this._staffService.getInstructorById(this.instructorId).subscribe((res => {
      console.log('Get Instructor Detail', res[0]);
      this.instructor = res[0];
      console.log("Got inst details", this.instructor);
      if (this.instructor) {
        if (this.instructor && this.instructor.userId && this.instructor.userId.userRole.length == 1 && this.instructor.userId.userRole.includes('incidentUser')) {
          this.isStaff = false
        }
        else {
          this.isStaff = true
        }

        let trainer = res[0].userId.userRole.includes('trainer')
        let operative = res[0].userId.userRole.includes('operative')
        console.log("trainer,operative value------>", trainer, operative);
        if (trainer || operative) {
          this.numDisplay = true
        }
        this.name = this.instructor.name;
        this.profilePath = this.instructor.profilePic;
        this.mobile = this.instructor.mobile;
        this.email = this.instructor.email;
        this.dateOfJoining = new Date(this.instructor.dateOfJoining);
        this.deletedUser = this.instructor.isDelete
        this.insuranceNumber = this.instructor.insuranceNumber
        this.sentinelNumber = this.instructor.sentinelNumber


        // if (this.instructor.isDelete == true) {
        //   console.log("call or not");
        //   this.deletedUser = true
        // }
      }
    }))
  }

  getMp() {
    this._mpService.getPractitionerById(this.mpId).subscribe(res => {
      console.log("res in profile", res)
      this.mp = res
      if (this.mp) {
        console.log("IN IF---------")
        this.isStaff = true
        this.name = this.mp.name;
        this.profilePath = this.mp.profilePic;
        this.mobile = this.mp.mobile;
        this.email = this.mp.email;
        this.dateOfJoining = new Date(this.mp.dateOfJoining);
        this.deletedUser = this.mp.isDelete
        // if (this.mp && this.mp.isDelete == true) {
        //   this.deletedUser = true
        // } else {
        //   this.deletedUser = false
        // }
      }
    })
  }

  getTestedIndividual(params) {
    console.log("what is the params ", params);

    this._testedIndividualService.getTestedIndividual(this.testedIndividualId).subscribe(res => {
      console.log("User is", res)
      this.tedtedIndividual = res[0]
      this.learner = res[0]
      this.name = res[0].name
      this.email = res[0].email
      this.displayUserName = true
      console.log("here we get single job data", this.jobId);

      this.getMpJob(this.jobId)
    })
  }

  getMpJob(jobId?) {
    console.log("send job id", jobId);
    this.activatedRoute.queryParams.subscribe(qparams => {

      let newJobId = qparams.jobId
      this._jobService.getMpJobById(newJobId).subscribe((response) => {
        console.log("response of mp jobs", response);
        this.job = response[0]
        this.isMpLearner = true
        this.client = this.job.clients
        // this.instructor = response[0].mps
      })
    })
  }


  getJob(id) {
    console.log("get bob by id", id);
    console.group("!!!!!!!!!")

    this._jobService.getJobById(id).subscribe((jobRecieved2) => {
      console.log("Job Recieved", JSON.parse(JSON.stringify(jobRecieved2.data)));
      console.log("%cJob Recieved", "color:red", jobRecieved2.data[0]);
      this.job = JSON.parse(JSON.stringify(jobRecieved2.data[0]));
      this.getJobValues(this.job)

      console.groupEnd()

    })
  }
  getJobValues(job) {
    console.log("%cGETTING VALUES OF JOB", "color:red", this.job);
    if (job.clients) {
      console.log("%cIN IF", "color:purple", job.client);

      this.client = job.clients;
      if (job.location) {
        this.location = job.location.title;
      }
      // this.location = job.location.title;
      this.course = job.course;
      this.instructor = job.instructors;
      this.jobTitle = job.title
    }
    else if (job[0].clients) {
      // console.log("%cIN ELSE IF", "color:purple", job[0].client);
      this.client = job[0].clients;
      if (job[0].location) {
        console.log("IN IF AGAIN", job[0].location);
        this.location = job[0].location.title;
      }
      this.course = job[0].course;
      this.instructor = job[0].instructors;
      this.jobTitle = job[0].title
    }
    console.log("single course details===========", this.instructor);

  }

  editLearner() {
    this.openDialog(EditLearnerModalComponent, this.learner).subscribe((data) => {
      console.log("DIALOG CLOSED", data)
      this.getLearner();
      // Handle Error
      if (!data) return;// this.openSnackBar("learner could not be edited","Ok");
      if (data.result == "err") return this.openSnackBar("Learner could not be edited!", "Ok");

      // EDIT HANDLE
      if (data.action == 'edit') {
        console.log("HANDLING EDIT SUCCESS", data);
        data = data;
        this.getLearner()


        this.handleSnackBar({ msg: "Learner edited successfully!", button: "Ok" });
      }
      // DELETE HANDLE
      else if (data.action == 'delete') {
        console.log("Deleted ", data);
        this.learner.splice(this.learner.findIndex(function (i) {
          return i._id === data.data._id;
        }), 1);
        this.handleSnackBar({ msg: "Learner deleted successfully!", button: "Ok" });
      }
      // this.updateData(this.learners);
    });
  }

  editInstructor(index, data) {
    data = this.instructor;
    console.log("DATA", data);
    console.log("instructorJobs", this.instructorJobs);
    console.log("job of instructors", this.jobByInstructorId);

    let dataArr = [];
    dataArr.push(data);
    if (this.jobByInstructorId == undefined) {
      this._jobService.getJobByInstructorId(data._id).subscribe((response) => {
        console.log("what is in data", response);
        this.jobByInstructorId = response.finalJobArray
        dataArr.push(this.jobByInstructorId)
        this.openDialog(EditStaffModalComponent, dataArr).subscribe((instructor) => {
          console.log("DIALOG CLOSED", instructor)
          this.getInstructor();
          // Handle Undefined

          if (!instructor) { return }

          // Handle Error

          if (instructor && instructor.result == "err") return this.openSnackBar("User could not be edited!", "Ok");

          // EDIT HANDLE
          if (instructor && instructor.action == 'edit') {
            console.log("HANDLING EDIT SUCCESS", instructor.data);
            console.log('This Instructor after update:', this.instructor);
            this.handleSnackBar({ msg: "User edited successfully!", button: "Ok" });
          }
          if (instructor && instructor.action == 'delete') {
            console.log("HANDLING DELETE SUCCESS", instructor.data);
            this.handleSnackBar({ msg: "User deleted successfully!", button: "Ok" });
          }

        });
      })
    } else {
      dataArr.push(this.jobByInstructorId);
      console.log("what is data array", dataArr);
      this.openDialog(EditStaffModalComponent, dataArr).subscribe((instructor) => {
        console.log("DIALOG CLOSED", instructor)
        this.getInstructor();
        // Handle Undefined

        if (!instructor) { return }

        // Handle Error

        if (instructor && instructor.result == "err") return this.openSnackBar("User could not be edited!", "Ok");

        // EDIT HANDLE
        if (instructor && instructor.action == 'edit') {
          console.log("HANDLING EDIT SUCCESS", instructor.data);
          console.log('This Instructor after update:', this.instructor);
          this.handleSnackBar({ msg: "User edited successfully!", button: "Ok" });
        }
        if (instructor && instructor.action == 'delete') {
          console.log("HANDLING DELETE SUCCESS", instructor.data);
          this.handleSnackBar({ msg: "User deleted successfully!", button: "Ok" });
        }

      });
    }
  }

  editTestedIndividual() {
    console.log('tedtedIndividual', this.tedtedIndividual)
    console.log("learner value=============", this.learner);
    this.tedtedIndividual['isEdit'] = true
    this.openDialog(AddCandidateModalComponent, this.tedtedIndividual).subscribe(res => {
      this.getTestedIndividual(this.testedIndividualId)
      if (res == undefined) return
      if (res && res.result == "err") return this.openSnackBar("Candidate could not be edited!", "Ok");
      if (res && res.action == 'edit') {
        console.log('edited candidate', res)
        this.tedtedIndividual = res.data
        this.learner = res.data
        this.name = res.data.name
        this.email = res.data.email
      }
      else if (res && res.action == 'delete') {
        console.log("HANDLING DELETE SUCCESS", res.data);
        this.handleSnackBar({ msg: "Candidate deleted successfully!", button: "Ok" });
        this.router.navigateByUrl('/mpjob/' + this.jobId)
      }
    })
  }

}
